"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmoteConfigSchema = exports.SceneConfigSchema = exports.WearableConfigSchema = exports.BuilderConfigSchema = void 0;
const schemas_1 = require("@dcl/schemas");
const types_1 = require("../item/types");
exports.BuilderConfigSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            nullable: true
        },
        collectionId: {
            type: 'string',
            nullable: true
        }
    },
    additionalProperties: false,
    required: []
};
exports.WearableConfigSchema = {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            nullable: true
        },
        description: {
            type: 'string',
            nullable: true,
            maxLength: 64
        },
        rarity: {
            ...types_1.Rarity.schema,
            nullable: true
        },
        name: {
            type: 'string'
        },
        data: {
            type: 'object',
            properties: {
                replaces: {
                    type: 'array',
                    items: schemas_1.HideableWearableCategory.schema
                },
                hides: {
                    type: 'array',
                    items: schemas_1.HideableWearableCategory.schema
                },
                tags: {
                    type: 'array',
                    items: {
                        type: 'string',
                        minLength: 1
                    }
                },
                representations: {
                    type: 'array',
                    items: schemas_1.WearableRepresentation.schema,
                    minItems: 1
                },
                category: types_1.WearableCategory.schema,
                removesDefaultHiding: {
                    type: 'array',
                    nullable: true,
                    items: schemas_1.HideableWearableCategory.schema
                },
                blockVrmExport: {
                    type: 'boolean',
                    nullable: true
                }
            },
            required: ['replaces', 'hides', 'tags', 'representations', 'category']
        },
        mappings: {
            ...schemas_1.Mappings.schema,
            nullable: true
        }
    },
    additionalProperties: false,
    required: ['name', 'data']
};
exports.SceneConfigSchema = schemas_1.Scene.schema;
exports.EmoteConfigSchema = {
    type: 'object',
    properties: {
        name: {
            type: 'string',
            nullable: true
        },
        description: {
            type: 'string',
            nullable: true,
            maxLength: 64
        },
        rarity: {
            ...types_1.Rarity.schema,
            nullable: true
        },
        category: {
            ...schemas_1.EmoteCategory.schema,
            nullable: true
        },
        play_mode: {
            ...schemas_1.EmotePlayMode.schema,
            nullable: true
        },
        tags: {
            type: 'array',
            items: {
                type: 'string',
                minLength: 1
            },
            nullable: true
        }
    },
    additionalProperties: true,
    required: []
};
//# sourceMappingURL=schemas.js.map